import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=6e733821&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e733821",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e733821')) {
      api.createRecord('6e733821', component.options)
    } else {
      api.reload('6e733821', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=6e733821&scoped=true&", function () {
      api.rerender('6e733821', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hc/customer/edit.vue"
export default component.exports